export default __webpack_public_path__ + "static/media/Ashoka_Particle_Flame_8.2185fb3d.png";